module.exports = __webpack_public_path__ + "static/media/user.5db7d294.png";